import { useEffect, useState } from 'react';

const useInitialClubLoading = (loadingSorted: boolean) => {
  const [loading, setLoading] = useState(true);
  // TODO loading state with widget model
  const isWidgetLoading = false;

  useEffect(() => {
    if (!loading || loadingSorted) return;

    if (loading && !isWidgetLoading) {
      setLoading(isWidgetLoading);
    }
  }, [isWidgetLoading, loading, loadingSorted]);

  return loading;
};

export default useInitialClubLoading;
